import React from 'react';

import { ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Checkbox, Chip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { AssetItem, RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';
import action_library_messages from 'messages/action_library_messages';
import assets_messages from 'messages/assets_messages';

import { useImportanceHelpers } from '../utils/importanceHelpers';

interface AssetListItemProps {
  asset: RecommendedAsset | AssetItem;
  isSelected: boolean;
  onToggle: () => void;
  isRecommended?: boolean;
}

const AssetListItem: React.FC<AssetListItemProps> = ({ asset, isSelected, onToggle, isRecommended = false }) => {
  const { t } = useTranslation();
  const { getLabel, getColor } = useImportanceHelpers();

  const isRecommendedAsset = isRecommended && 'type' in asset && 'importance' in asset;
  const recommendedAsset = isRecommendedAsset ? (asset as RecommendedAsset) : null;
  const regularAsset = !isRecommendedAsset ? (asset as AssetItem) : null;

  const ownerFullName = recommendedAsset
    ? `${recommendedAsset.owner.profile.firstName} ${recommendedAsset.owner.profile.lastName}`.trim()
    : regularAsset?.owner.fullName || '';

  const secondaryText = recommendedAsset
    ? `${t(assets_messages.assets_table.owner)}: ${ownerFullName} | ${t(assets_messages.assets_table.category)}: ${
        recommendedAsset.category.name
      } | Type: ${recommendedAsset.type}`
    : t(action_library_messages.instance.asset_selection.asset_details_format, {
        ownerLabel: t(assets_messages.assets_table.owner),
        ownerName: ownerFullName,
        categoryLabel: t(assets_messages.assets_table.category),
        categoryName: regularAsset?.category?.name || '',
      });

  return (
    <ListItem button onClick={onToggle}>
      <ListItemIcon>
        <Checkbox checked={isSelected} color='primary' edge='start' />
      </ListItemIcon>
      <ListItemText primary={asset.name} secondary={secondaryText} />
      <ListItemSecondaryAction>
        {recommendedAsset && (
          <Chip
            label={getLabel(recommendedAsset.importance)}
            size='small'
            style={{
              backgroundColor: getColor(recommendedAsset.importance),
              color: '#fff',
            }}
          />
        )}
        {regularAsset?.category && <Chip label={regularAsset.category.name} size='small' style={{ marginRight: 8 }} />}
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default AssetListItem;
